import auth0 from 'auth0-js'
import EventEmitter from 'events'
import authConfig from '@/../auth_config.json'

// import store from '@/store/index.js'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn'

// const tokenExpiryKey = 'tokenExpiry'
const loginEvent = 'loginEvent'
const accessToken = 'accessToken'
// const refreshToken = 'refreshToken'

const webAuth = new auth0.WebAuth({
  domain: `${authConfig.domain}/connect`,
  redirectUri: `${window.location.origin + process.env.BASE_URL}callback`,
  clientID: authConfig.clientId,
  responseType: 'token id_token',
  responseMode: 'fragment',
  scope: 'openid web_api profile',
  overrides: {
    __token_issuer: 'https://account.gjirafa.tech',
    __jwks_uri: 'https://account.gjirafa.tech/.well-known/openid-configuration/jwks',
  },
  jwksURI: 'https://account.gjirafa.tech/.well-known/openid-configuration/jwks',
})

class AuthService extends EventEmitter {
    idToken = null;

    profile = null;
    // tokenExpiry = null;

    // Starts the user login flow
    login(customState) {
      webAuth.authorize({
        appState: customState,
      })
    }

    // Handles the callback request from Auth0
    handleAuthentication() {
      return new Promise((resolve, reject) => {
        webAuth.parseHash((err, authResult) => {
          if (err) {
            alert(`${err.error}. Detailed error can be found in console.`)
            reject(err)
          } else {
            this.localLogin(authResult)
            resolve(authResult.f)
          }
        })
      })
    }

    localLogin(authResult) {
      const userData = {
        id: 1,
        fullName: 'Jona',
        username: 'johndoe',
        password: 'admin',
        // eslint-disable-next-line global-require
        avatar: '',
        email: 'admin@demo.com',
        role: 'admin',
        ability: [
          {
            action: 'manage',
            subject: 'all',
          },
        ],
        extras: {
          eCommerceCartItemsCount: 5,
        },
      }
      localStorage.setItem('userData', JSON.stringify(userData))
      this.idToken = authResult.idToken
      this.profile = authResult.idTokenPayload
      const token = authResult.accessToken
      localStorage.setItem('token', token)
      // axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

      // Convert the JWT expiry time from seconds to milliseconds
      // this.tokenExpiry = new Date(this.profile.exp * 10000)
      // localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
      localStorage.setItem(localStorageKey, 'true')
      localStorage.setItem(accessToken, token)
      // localStorage.setItem(refreshToken, token)

      this.emit(loginEvent, {
        loggedIn: true,
        profile: authResult.accessToken,
        state: authResult.appState || {},
      })
    }

    renewTokens() {
      // reject can be used as parameter in promise for using reject
      // return new Promise(resolve => {
      //   if (localStorage.getItem(localStorageKey) !== 'true') {
      //     // return reject('Not logged in');
      //   }

      //   webAuth.checkSession({}, (err, authResult) => {
      //     if (err) {
      //       // reject(err);
      //     } else {
      //       this.localLogin(authResult)
      //       resolve(authResult)
      //     }
      //   })
      // })
    }

    logOut() {
      localStorage.removeItem(localStorageKey)
      // localStorage.removeItem(tokenExpiryKey)
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')

      this.idToken = null
      // this.tokenExpiry = null
      this.profile = null

      webAuth.logout({
        returnTo: window.location.origin + process.env.BASE_URL,
      })

      this.emit(loginEvent, { loggedIn: false })
    }

    isAuthenticated() {
      return (
        // new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) &&
        localStorage.getItem(localStorageKey) === 'true'
      )
    }
}

export default new AuthService()
